export default __webpack_public_path__ + "static/media/ic_header_arrow_right.e8c694fc.svg";